<!--  -->
<template>
  <div class="orderMain">
    <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
      <el-tab-pane label="会员日志" name="eleven"> </el-tab-pane>
      <el-tab-pane label="会员成绩日志" name="twelve"> </el-tab-pane>
      <el-tab-pane label="会员比赛日志" name="thirteen"> </el-tab-pane>
      <el-tab-pane label="日榜" name="six"> </el-tab-pane>
      <el-tab-pane label="组数王" name="seven"> </el-tab-pane>
      <el-tab-pane label="资讯管理" name="one"> </el-tab-pane>
      <el-tab-pane label="活动管理" name="two"> </el-tab-pane>
      <el-tab-pane label="活动报名" name="three"> </el-tab-pane>
      <el-tab-pane label="赛事管理" name="four"> </el-tab-pane>
      <el-tab-pane label="日榜管理" name="five"> </el-tab-pane>

      <el-tab-pane label="段位管理" name="eight"> </el-tab-pane>
      <el-tab-pane label="勋章管理" name="nine"> </el-tab-pane>
      <el-tab-pane label="订单项管理" name="ten">
        <div>
          <div class="title_div">
            <span class="title-span">自定义项名称：</span>
            <el-input
              clearable
              size="small"
              class="title-select"
              v-model="selfParams.name"
              placeholder="请输入自定义项名称"
              @input="inputRuleParams"
            ></el-input>
            <!--  -->
            <span class="title-span" style="margin-left: 30px">创建时间：</span>
            <el-date-picker
              @change="dateChange"
              v-model="selfParams.createDateStart"
              size="small"
              class="title-date1"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择开始日期"
            >
            </el-date-picker>
            至
            <el-date-picker
              @change="dateChange"
              v-model="selfParams.createDateEnd"
              size="small"
              class="title-date2"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择结束日期"
            >
            </el-date-picker>
            <!--  -->
          </div>
          <div>
            <el-button
              class="creat-button"
              type="primary"
              size="small"
              @click="addselfClick"
              >新增自定义项
            </el-button>
          </div>
          <div class="mm-tb">
            <el-table :data="seltList" style="width: 100%">
              <el-table-column
                type="index"
                label="序号"
                align="center"
                width="80"
              >
              </el-table-column>
              <el-table-column prop="name" label="自定义项名称" align="center">
              </el-table-column>
              <el-table-column prop="createBy" label="创建人" align="center">
              </el-table-column>
              <el-table-column
                prop="createDate"
                label="创建时间"
                align="center"
              >
              </el-table-column>
              <el-table-column prop="updateBy" label="修改人" align="center">
              </el-table-column>
              <el-table-column
                prop="updateDate"
                label="修改时间"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="realName"
                label="操作"
                width="150"
                align="center"
              >
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="medium"
                    @click="editSelf(scope.row)"
                    >编辑</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div>
            <el-pagination
              class="mm-page"
              @size-change="SizeChange"
              @current-change="selfCurrentChange"
              :current-page="seltResult.current"
              :page-size="seltResult.size"
              layout="total,prev, pager, next, sizes"
              :total="seltResult.total"
              :page-sizes="[10, 20, 30, 40, 50]"
            >
            </el-pagination>
          </div></div
      ></el-tab-pane>
    </el-tabs>
    <el-dialog
      :title="selfTitle"
      :visible.sync="addselfDialogVisible"
      width="580px"
      :close-on-click-modal="false"
    >
      <div style="margin: 20px">自定义项名称:</div>
      <el-input
        size="small"
        style="width: 500px"
        v-model="selfName"
        placeholder="自定义项名称最多輸入4个汉字"
        maxlength="4"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closSelfDialogVisible">取 消</el-button>
        <el-button type="primary" @click="addorEditSelf">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getOrderCustomizationPage,
  addOrderCustomization,
  updateAntOrderCustomName,
} from "../../api/OperationManagement";
export default {
  name: "10MedalManagement",
  data() {
    return {
      activeName: "ten",
      seltList: [],
      seltResult: {},
      selfParams: {
        name: "",
        pageNo: 1,
        pageSize: 10,
        createDateStart: "",
        createDateEnd: "",
      },
      addselfDialogVisible: false,
      selfName: "",
      selfTitle: "",
    };
  },
  created() {},
  mounted() {
    this.getOrderCustomizationPage(this.selfParams);
  },
  methods: {
    handleClick(tab, event) {
      if (tab.label == "资讯管理") {
        this.$router.push("/OperationManagement/1InformationManagement");
      } else if (tab.label == "活动管理") {
        this.$router.push("/OperationManagement/2ActivityManagement");
      } else if (tab.label == "活动报名") {
        this.$router.push("/OperationManagement/3ActivityRegistration");
      } else if (tab.label == "赛事管理") {
        this.$router.push("/OperationManagement/4EventManagement");
      } else if (tab.label == "日榜管理") {
        this.$router.push("/OperationManagement/5RankingList");
      } else if (tab.label == "日榜") {
        this.$router.push("/OperationManagement/6ListManagement");
      } else if (tab.label == "组数王") {
        this.$router.push("/OperationManagement/7GroupNumberList");
      } else if (tab.label == "段位管理") {
        this.$router.push("/OperationManagement/8RankManagement");
      } else if (tab.label == "勋章管理") {
        this.$router.push("/OperationManagement/9MedalManagement");
      } else if (tab.label == "订单项管理") {
        // this.$router.push("/OperationManagement/10MedalManagement");
      } else if (tab.label == "会员日志") {
        this.$router.push("/OperationManagement/11MedalManagement");
      } else if (tab.label == "会员成绩日志") {
        this.$router.push("/OperationManagement/12MedalManagement");
      } else if (tab.label == "会员比赛日志") {
        this.$router.push("/OperationManagement/13MedalManagement");
      }
    },
    getOrderCustomizationPage(params) {
      getOrderCustomizationPage(params).then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
            this.seltResult = res.data.result;
            this.seltList = res.data.result.records;
          } else {
            this.seltResult = res.data.result;
            this.seltList = res.data.result.records;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    inputRuleParams() {
      this.selfParams.pageNo = 1;
      this.getOrderCustomizationPage(this.selfParams);
    },
    SizeChange(newSize) {
      this.selfParams.pageSize = newSize;
      this.getOrderCustomizationPage(this.selfParams);
    },
    selfCurrentChange(newPage) {
      this.selfParams.pageNo = newPage;
      this.getOrderCustomizationPage(this.selfParams);
    },
    closSelfDialogVisible() {
      this.addselfDialogVisible = false;
      this.selfName = "";
      this.id = "";
    },
    editSelf(row) {
      this.addselfDialogVisible = true;
      this.selfName = row.name;
      this.id = row.id;
      this.selfTitle = "编辑";
    },
    addorEditSelf() {
      if (this.selfName) {
        if (this.selfTitle == "编辑") {
          updateAntOrderCustomName({
            id: this.id,
            name: this.selfName,
          }).then((res) => {
            if (res.status === 200 && res.data.success) {
              this.$message.success("编辑成功");
              this.closSelfDialogVisible();
              this.getOrderCustomizationPage(this.selfParams);
            } else {
              this.$message.error(res.data.message);
            }
          });
        } else if (this.selfTitle == "新增") {
          let flag = true;
          this.seltList.map((item) => {
            if (item.name == this.selfName) {
              console.log(1);
              flag = false;
            }
          });
          if (flag) {
            addOrderCustomization({
              name: this.selfName,
            }).then((res) => {
              if (res.status === 200 && res.data.success) {
                this.$message.success("新增成功");
                this.closSelfDialogVisible();
                this.getOrderCustomizationPage(this.selfParams);
              } else {
                this.$message.error(res.data.message);
              }
            });
          } else {
            this.$message.error("避免添加重复项");
          }
        }
      } else {
        this.$message.error("请填写内容");
      }
    },
    addselfClick() {
      this.addselfDialogVisible = true;
      this.selfTitle = "新增";
      this.selfName = "";
    },
    dateChange() {
      if (
        this.selfParams.createDateStart &&
        this.selfParams.createDateEnd &&
        new Date(this.selfParams.createDateStart).getTime() >
          new Date(this.selfParams.createDateEnd).getTime()
      ) {
        this.$message.error("开始时间不能大于结束时间");
        return;
      }
      this.selfParams.pageNo = 1;
      this.getOrderCustomizationPage(this.selfParams);
    },
  },
};
</script>
<style scoped>
.title-span {
  font-size: 16px;
}
.orderMain {
  padding: 30px;
}

.title_div {
  margin: 20px 30px;
}

.title-select {
  width: 200px;
}

.title-date1 {
  width: 180px;
}

.title-date2 {
  width: 180px;
}

.creat-button {
  margin: 20px 80px;
}

.mm-tb {
  width: 90%;
  margin-left: 50px;
}

.mm-page {
  margin: 30px 60px;
}
</style>